export default function NewsletterForm(_wrapper) {
    this.$wrapper = $(_wrapper);
    this.$tup = {}
    this.$cf7Form = {}
    this.$form = {}

    this.init = () => {
        if (this.$wrapper.length > 0) {
            this.$form = this.$wrapper.find('.m-frm-wrapper__form');
            this.$tup = this.$wrapper.find('.m-frm-wrapper__tup');
            this.$cf7Form = this.$wrapper.find('.wpcf7-form');
            this.hideSuccess();
            this.initListeners();
        }
    }
    this.reset = () => {
        this.hideSuccess();
        this.showForm();
    }
    this.initListeners = () => {
        this.$cf7Form[0].addEventListener('wpcf7mailsent', this.success, false);
    }

    this.success = () => {
        this.hideForm();
        this.showSuccess();
    }

    this.showForm = () => {
        this.$form.addClass('d-block');
        this.$form.removeClass('d-none');
    }

    this.hideForm = () => {
        this.$form.removeClass('d-block');
        this.$form.addClass('d-none');
    }

    this.showSuccess = () => {
        this.$tup.removeClass('d-none');
        this.$tup.addClass('d-flex');
    }

    this.hideSuccess = () => {
        this.$tup.removeClass('d-flex');
        this.$tup.addClass('d-none');
    }
}
